import { render, staticRenderFns } from "./UiMenuBar.vue?vue&type=template&id=06045f3e&scoped=true"
import script from "./UiMenuBar.vue?vue&type=script&lang=ts"
export * from "./UiMenuBar.vue?vue&type=script&lang=ts"
import style0 from "./UiMenuBar.vue?vue&type=style&index=0&id=06045f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06045f3e",
  null
  
)

export default component.exports